module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/main-3e5d3284e20cb6f110f618921e462dab.jpg";